import React from 'react'
import { useAtom } from 'jotai'
import { ConversationType } from '../../../generated/api/chat-conversations'
import { ChatHeaderState, chatHeaderStateAtom } from '../atom'
import { ConversationsList } from './ConversationsList'
import { useChatErrorState } from './useChatErrorState'
import { useConversations } from './useConversations'

interface ChatConversationsProps {
  type: ConversationType
  societyIds?: string[]
}

export const ChatConversations = ({
  type,
  societyIds,
}: ChatConversationsProps): React.ReactNode => {
  const [, setChatHeaderState] = useAtom(chatHeaderStateAtom)
  const { rows, isLoading } = useConversations({
    type,
    state: 'active',
    societyIds,
  })

  useChatErrorState({
    type,
    isEmpty: rows.length === 0,
    showSpinner: isLoading,
  })

  return (
    <ConversationsList
      type={type}
      state="active"
      societyIds={societyIds}
      className="px-2"
      rowClassName="rounded-md p-4"
      onRowClick={() => setChatHeaderState(ChatHeaderState.None)}
    />
  )
}
